import { useDeleteTag, useTag, useUpsertTag } from '@/hooks';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { TagForm } from './TagForm';

export function Tag() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    query: { data: tag },
  } = useTag(id);
  const { mutate: upsertTag } = useUpsertTag();
  const { mutate: deleteTag } = useDeleteTag();

  function handleDelete() {
    deleteTag(id, {
      onSuccess: () => {
        navigate('..', { replace: true });
      },
    });
  }

  function handleSubmit(values) {
    upsertTag(values, {
      onSuccess: (data) => {
        navigate(`../${data.identifier}`, { replace: true });
      },
    });
  }

  return (
    <Box sx={{ flexGrow: 1, p: 1, bgcolor: 'background.paper' }}>
      <title>
        {['IR3', 'Tags', tag?._id ? tag.title : 'New Tag']
          .filter(Boolean)
          .join(' | ')}
      </title>
      <TagForm
        key={[tag?._id, tag?.lastEdit?.time]}
        defaultValues={tag}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
      />
    </Box>
  );
}
